import Reout from './Reout';
import GoogleAnalytics from './GoogleAnalytics';
import API from './API';
import { head_set_meta } from './head';
import { current_site_id } from './Site';

/* Semi-configured Reout subclass, with aktiedysten.dk-specific language
 * awareness, but without the actual routes (see routes.js which in turn
 * subclasses ReoutBase); the reason for this class to avoid a circular import
 * dependency elsewhere (the cycle occurs because routes.js imports all page
 * components via routes.autogen.js; this includes virtually everything) */

class ReoutBase extends Reout {
	get_default_language() {
		if (IS_AKTIEDYSTEN_DK) {
			return "da";
		} else if (IS_AKTIEKAMPEN_SE) {
			return "sv";
		} else if (IS_INVESTSPIEL_DE) {
			return "de";
		} else if (IS_TRADERR_COM) {
			return "en";
		}
	}

	get_language_prefixes() {
		return ["en"];
	}

	on_pageview(path, n) {
		if (n > 0) {
			GoogleAnalytics.pageview(path);
			API.get("/z/meta", {site: current_site_id, path}, (response) => {
				head_set_meta(response);
			});
		}
	}
}

export default ReoutBase;



// WEBPACK FOOTER //
// ./src/reout-base.js